// Public schema enums and all server market selectors share this map.
export const AGENT_MARKET_COUNTRY = Object.freeze({
  us:"US",uk:"GB",ie:"IE",ca:"CA",au:"AU",nz:"NZ",za:"ZA",de:"DE",fr:"FR",es:"ES",
  it:"IT",pt:"PT",dk:"DK",se:"SE",mt:"MT",br:"BR",co:"CO",ec:"EC",mx:"MX",be:"BE",
  pl:"PL",sk:"SK",no:"NO",bg:"BG",fi:"FI",nl:"NL",ch:"CH",ar:"AR",lt:"LT",lv:"LV",
});
